import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ServicerProvider } from './servicer';
import { AppMonitorResponse } from './models/app-monitor-response';

const BASE_URL = '/v2/appMonitor';

/**
 * [システム] アラート のプロバイダー.
 */
@Injectable()
export class AppMonitorServiceProvider {

  constructor(
    private servicer: ServicerProvider
  ) { }

  /**
   * appMonitor情報を取得.
   *
   * @returns Observable<GenericList<SystemAlerts>>
   */
  get(): Observable<AppMonitorResponse> {
    const url = `${BASE_URL}`;
    return this.servicer.get<AppMonitorResponse>(url);
  }
}



// WEBPACK FOOTER //
// ./src/providers/servicer/app-monitor-service.ts